module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Chapitre Trois")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold",
      "font-size": "1.00em",
      "text-transform": "uppercase"
    }
  }, [_vm._v("ADAM")]), _vm._v(" rentra finalement dans sa chambre, une demi-heure plus tard, après avoir quitté le centre de plongée et récupéré les tongs qu’il avait oubliées sur la plage. Il était sur le point d’ôter son maillot de bain lorsque son portable sonna.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Adam ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Salut, Karen.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Écoute, je suis désolée de te déranger pendant tes vacances…, dit sa sœur, l’air vraiment contrarié.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Mais… ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tu sais que je ne t’appellerais pas si je ne pensais pas que tu devais être mis au courant, répondit-elle.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— John Morgan d’Entech a appelé.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Comment le sais-tu ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il a d’abord appelé sur mon portable. Je l’ai ignoré.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tu as des couilles, Addy.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’en avais la dernière fois que j’ai vérifié, répondit-il en soupirant avant de s’allonger sur le lit, le téléphone coincé entre son épaule et son oreille.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— C’est vrai.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Les choses devaient être pires qu’il ne le pensait. Elle riait toujours de ses stupides réparties.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il a appelé maman aussi, dit-elle.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il a "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("quoi")]), _vm._v(" ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il sauta du lit et se dirigea vers la fenêtre. Dehors, le soleil avait finalement disparu sous l’horizon, illuminant le ciel de teintes rouges et d’oranges brillantes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il l’a appelée ce matin, visiblement. Elle lui a dit qu’elle ne souhaitait pas vendre ses actions, mais il l’a convaincue de convoquer une réunion avec nous tous.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Inspire profondément")]), _vm._v(". Bien sûr, le serpent appelait sa mère, probablement parce qu’il pensait qu’elle était un fruit à portée de sa main. Entech aurait une chance de racheter Prestco avec ses actions et celles de Roger. Ce dernier avait déjà mis la pression sur leur mère ; maintenant, une personne extérieure s’en occupait.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Quand ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Le 28.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("On était le 31 janvier. Cela lui donnait un mois pour trouver comment contrer la stratégie d’Entech.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je prendrai l’avion pour les États-Unis demain et nous pourrons…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Hors de question, bon sang.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Mais…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Il n’y a rien que tu puisses faire ici et qui ferait la moindre différence, répliqua-t-elle d’une voix dure. Je n’ai pas passé les deux derniers mois à essayer de te faire prendre des vacances afin que tu reviennes juste après ton atterrissage.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Maman a déjà assez de mal avec Roger qui la pousse à vendre. Si je reviens, je pourrai…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tu auras encore trois semaines pour te préparer lorsque tu rentreras à la maison. En plus, j’ai convaincu maman de venir de Floride avant la réunion. Elle restera avec Kenny et moi à la maison. Elle arrive mardi. Je lui parlerai.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Oh. Tu es douée, dit Adam en souriant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Merci.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Il pouvait presque voir le sourire de sa sœur.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Comment as-tu fait ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sa mère ne se rendait presque jamais nulle part, encore moins jusqu’à la baie de San Francisco. Elle y retournait rarement depuis la mort de leur père. En fait, il ne se souvenait pas de la dernière fois qu’elle était venue lui rendre visite.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’ai mes méthodes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Crache le morceau, femme.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Elle préparait quelque chose et il voulait s’assurer qu’il n’y avait pas lieu de s’inquiéter.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je lui ai peut-être dit que j’avais besoin d’aide. Tu sais, dans la maison, avec Kenny qui voyage plus pour son travail et moi qui doit préparer les affaires pour le bébé et tout.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Le cerveau d’Adam se figea.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Tu es… tu es…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Nous attendons un bébé, dit-elle triomphalement. Qu’en penses-tu, "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("oncle")]), _vm._v(" Addy ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Félicitations !")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Ken et elle essayaient depuis près de cinq ans. Bien sûr, s’ils réussissaient à empêcher la société d’être avalée par les requins d’Entech, Adam devrait embaucher quelqu’un pour l’aider à gérer l’entreprise pendant que sa sœur serait en congé, mais c’était un problème qui ne le préoccupait pas.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Merci. Nous sommes ravis.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Garçon ou fille ? demanda-t-il.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Nous ne voulons pas le savoir à l’avance, dit-elle. Kenny dit que c’est une fille. Je lui ai dit que c’était un garçon. Nous avons environ six mois avant de le découvrir.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je suis si content pour vous.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Nous sommes heureux, nous aussi, répondit-elle en riant. Nous avions arrêté les traitements six mois avant environ. Je suppose que c’était le destin.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Vous ferez de super parents.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je pense qu’il est temps que la vieille maison ait un peu de sang neuf. J’arriverai peut-être à convaincre maman de revenir.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— S’il y a bien quelqu’un qui le peut, c’est toi, affirma-t-il en souriant.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Donc, je n’ai pas à m’inquiéter que tu te pointes à ma porte demain, d’accord ? Tu ne bouges pas de là ?")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je te fais confiance pour éloigner maman de Morgan et de son équipe.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Sa sœur était une femme d’affaires rusée et elle garderait leur mère occupée. Merde, leur mère avait même dû sauter d’elle-même dans le prochain avion vers l’ouest.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Heureuse de l’entendre, répliqua-t-elle en riant. Et si tu te présentes ici même une heure avant ton vol de retour…")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— J’ai compris. Je resterai, tant que tu me tiendras au courant. Tu sais que je serai cent fois plus stressé si tu ne me dis pas ce qui se passe.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Marché conclu. Maintenant, va t’amuser un peu pour changer, ajouta-t-elle. Nous avons besoin que tu sois lucide et prêt à botter les fesses d’Entech à ton retour.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je compte sur ton aide pour ça.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("— Je n’ai pas abandonné la pratique du droit pour te laisser toute la partie amusante. Maintenant, va boire une boisson fruitée avec un parapluie ou un truc comme ça.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal",
    attrs: {
      "id": "a__Hlk527150022"
    }
  }, [_vm._v("— Promis, lui dit-il.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Mais il avait le sentiment qu’il aurait besoin d’une boisson un peu plus forte.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd50033e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section-0007.vue
// module id = 75
// module chunks = 0